<app-view-sponsor [(visible)]="displayViewMore" [property]="propertyDetail"></app-view-sponsor>
<app-header [pageName]="pageName"></app-header>

<app-sponsor-filters [(visible)]="displayFilters" (filterData)="getFilters($event)"></app-sponsor-filters>

<div class="page-header header-color">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h1 class="title">Welcome</h1>
        <p class="subtitle">Welcome to our market place Sponsorship page where you get a list of different sponsorship
          available to different Events and Industries including Sport, Educational, Technology and many more. </p>
        <!-- <p class="subtitle">Welcome to our market place where we provide a market place for event owners to register their properties (Events) along with the properties description, summary, perceived value, event date, attendance, category, location and more.</p> -->
      </div>
      <div class="col-md-6 d-flex justify-content-center">
        <img class="logo" src="../../assets/images/logo_white.png" alt="">
      </div>
    </div>

    <div>
      <form>
        <div class="input-group">
          <input type="text" name="searchText" class="form-control search-input border-0 small" [(ngModel)]="searchText"
            placeholder="Search for event..." aria-label="Search" aria-describedby="basic-addon2">
          <div class="input-group-append">
            <button class="btn btn-primary btn-search" (click)="onQuerySearch()" type="button">
              <i class="fa fa-search fa-sm"></i>
            </button>
          </div>
        </div>
      </form>

    </div>

    <div class="row mb-2 filter-button">
      <div class="col-md-12">
        <button type="button" (click)="onFilter()" class="btn btn-outline-light shadow lift">
          <p style="color: black; margin: 0; padding: 0">Filter</p>
        </button>
      </div>
    </div>

  </div>
  <br>

</div>

<div class="container-fluid mt-negative">

  <div class="row">

    <div id="sidebar" class="col-md-2 type_div">
      <div class="row ">
        <div class="card sidebar-card">
          <p class="ml"><b>Categories</b></p>
          <div class="form-check" *ngFor="let category of categories">
            <input class="form-check-input" [(ngModel)]="category.isSelected" (change)="onChecked($event)"
              type="checkbox" value={{category.value}} id="defaultCheck1">
            <label class="form-check-label" for="defaultCheck1">
              {{category.value}}
            </label>
          </div>

        </div>

      </div>
    </div>

    <div id="body-container" class="col">
      <div class="row d-flex justify-content-center" *ngIf="isLoading">
        <img class="loader" src="../../assets/images/loader.gif" alt="">
      </div>

      <!-- <div class="row mb-2 filter-button">
        <div class="col-md-12">
          <button type="button" (click)="onFilter()" class="btn btn-outline-light shadow lift">
            <i class="fa fa-filter"></i> Filter
          </button>
        </div>
      </div> -->

      <div class="row" *ngIf="searching && !searchResults">
        <div class="col-md-12">
          <h2>No records found</h2>
        </div>
        <div class="col-md-12">
          <p class="subtitle">There are no results matching your search : <b>{{displaySearchText}}</b></p>
        </div>
      </div>

      <div class="row" *ngIf="noRecords">
        <div class="col-md-12">
          <h2>No Sponsorships available</h2>
        </div>
        <div class="col-md-12">
          <p class="subtitle">Any available Sponsorships will be displayed here.</p>
        </div>
      </div>

      <div class="row" *ngIf="searching && searchResults">
        <div class="col-md-12">
          <h2>Search results:</h2>
        </div>
        <div class="col-md-12">
          <p class="subtitle">Search records found <b>( {{resultsValue}} )</b></p>
        </div>
      </div>


      <!-- <div class="row">
            <div class="col-md-12">
              <div class="card border-light mb-4 shadow propertyCard sponsorBG">
                <div class="header-box d-flex justify-content-center text-center"><h2 style="position:absolute;top: 40%;">Sponsorship</h2></div>
              </div>
            </div>
          </div> -->

      <div class="row card_div">
        <div class="col-sm-4" *ngFor="let source of propertiesData">
          <div (click)="onView(source)" class="card border-light mb-4 shadow propertyCard">
            <div class="card-body">
              <div class="vertical-center">
                <div class="row">
                  <div class="col-md-4 nogutters d-flex justify-content-center">
                    <img class="event_logo rounded" src={{imageBaseUrl+source._source.image_url}} alt="logo">
                  </div>
                  <div class="col-md-8 nogutters">
                    <h4 class="cardHeading nogutters">{{source._source.propName}}</h4>
                  </div>
                </div>

                <hr class="hr">

                <div class="row">
                  <p class="cardDescription">{{source._source.propDescription}}</p>
                </div>

                <div class="row" *ngIf="userGroup === 'sponsor'">
                  <button (click)="applySponsor()"
                    class="btn btn-lg btn-teal rounded-pill shadow lift lift-sm m-b-1">Apply</button>
                </div>

              </div>

              <img src="../../assets/images/arrow.svg" class="arrow" alt="">
            </div>
          </div>
        </div>
      </div>

    </div>


  </div>




</div>

<app-sponsors-login [(visible)]="displaySponsorsLogin"></app-sponsors-login>
<app-sponsors-register [(visible)]="displaySponsorsRegister"></app-sponsors-register>
<app-footer></app-footer>